import { Slider, Stack, Typography } from '@mui/material';
import { FilterField } from '@retail/components';

interface Props {
  label: string;
  valueRange: number[];
  setValueRange: (range: number[]) => void;
}

export const CHANGE_RANGE_MIN = -51;
export const CHANGE_RANGE_MAX = 51;

const formatLabel = (value: number) => {
  if (value <= -50) return '< -50%';
  if (value >= 50) return '> 50%';
  return `${value}%`;
};

export function ValueSpanSlider({ label, valueRange, setValueRange }: Props) {
  const currentValue = [valueRange[0] ?? CHANGE_RANGE_MIN, valueRange[1] ?? CHANGE_RANGE_MAX];

  return (
    <FilterField label={label}>
      <Stack flexDirection="row" gap={2} alignItems="center">
        <Typography variant="body2" whiteSpace="nowrap">
          {formatLabel(CHANGE_RANGE_MIN)}
        </Typography>
        <Slider
          sx={{
            '& .MuiSlider-valueLabel': {
              top: 'auto !important',
              transform: 'none !important',
              bottom: '-26px !important',
              background: 'transparent',
              color: 'text.primary',
              fontSize: 12,
            },
            '& .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
              right: '0 !important',
              left: 'auto !important',
            },
            '& .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
              left: '0 !important',
              right: 'auto !important',
            },
          }}
          valueLabelFormat={formatLabel}
          value={currentValue}
          onChange={(_, newValue) => setValueRange(newValue as number[])}
          valueLabelDisplay="on"
          min={CHANGE_RANGE_MIN}
          max={CHANGE_RANGE_MAX}
        />
        <Typography variant="body2" whiteSpace="nowrap">
          {formatLabel(CHANGE_RANGE_MAX)}
        </Typography>
      </Stack>
    </FilterField>
  );
}
